(() => {
  const bind = (owner) => {
    if (owner.dataset.navBound) return;
    const trigger = owner.querySelector('[data-nav-group-trigger]');
    if (!trigger) return;
    owner.dataset.navBound = 'true';
    const panel = () => owner.querySelector('.tw-grouped-menu, .tw-compact-menu');
    const store = () => window.Alpine?.store('xHeaderMenu');
    const sync = () => trigger.setAttribute('aria-expanded', String(!!panel() && !panel().classList.contains('toggle-menu-hidden')));
    new MutationObserver(sync).observe(owner, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    owner.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        owner.setAttribute('data-nav-suppress-focus', '');
        trigger.focus();
        store()?.hideMenu(owner);
        owner.removeAttribute('data-nav-suppress-focus');
        sync();
      } else if (event.target === trigger && ['ArrowDown', ' '].includes(event.key)) {
        event.preventDefault();
        store()?.selectItem(owner);
        requestAnimationFrame(() => panel()?.querySelector('a')?.focus());
      }
    });
    owner.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!owner.contains(document.activeElement) && !owner.matches(':hover') && panel() && !panel().classList.contains('toggle-menu-hidden')) store()?.hideMenu(owner);
      });
    });
    sync();
  };
  const initialize = () => document.querySelectorAll('.tw-grouped-menu-owner, .tw-compact-menu-owner').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
